import { sendOmAndLetter, sendReportConsent } from "./sendOmLetterService";
import { 
  initSendOmLetter, 
  setSuccessMessage,
  sendOmLetterError,
  sendReportConsentError,
  cleanReportError, 
  setReportEmails,
  setOmLetterEmails,
  setReportFileName,
  setOmLetterFileName,
  setClearSuccessMessage ,
  clearReportFileName,
  clearOmLetterFileName
} from "./sendOmLetterSlice";

export const sendReportConsentLetterAction = (xlsx, emails) => async (dispatch) => {
  dispatch(initSendOmLetter());
  try {
    const response = await sendReportConsent(xlsx, emails);
    if (response.status === 201) {
      dispatch(setSuccessMessage(response.data.message));
      dispatch(clearReportFileName());
    } else {
      dispatch(sendReportConsentError(response.response.data.message));
    }
  } catch (error) {
    dispatch(sendOmLetterError(error.message));
  }
}

export const sendOmLetterAction = (xlsx, emails) => async (dispatch) => {
  dispatch(initSendOmLetter());
  try {
    const response = await sendOmAndLetter(xlsx, emails);
    if (response.status === 201) {
      dispatch(setSuccessMessage(response.data.message));
      dispatch(clearOmLetterFileName());
    } else {
      dispatch(sendOmLetterError(response.response.data.message));
    }
  } catch (error) {
    dispatch(sendOmLetterError(error.message));
  }
}

export const setReportEmailAction = (emails) => async (dispatch) => {
  dispatch(setReportEmails(emails));
}

export const setOmLetterEmailAction = (emails) => async (dispatch) => {
  dispatch(setOmLetterEmails(emails));
}

export const cleanReportErrorAction = () => async (dispatch) => {
  dispatch(cleanReportError());
}

export const setReportFileNameAction = (fileName) => async (dispatch) => {
  dispatch(setReportFileName(fileName));
}

export const setOmLetterFileNameAction = (fileName) => async (dispatch) => {
  dispatch(setOmLetterFileName(fileName));
}

export const setClearSuccessMessageAction = () => async (dispatch) => {
  dispatch(setClearSuccessMessage());
}